<div class="user-details">

    <div *ngIf="!UserEmpty()" class="title-header">
        <div class="title-left">
            <span class="material-icons-outlined">person</span>
            <span class="title-text">{{ userTitle | translate }}</span>
        </div>
        <div class="header-buttons" *ngIf="supervisor">
            <ng-container *ngIf="!editMode">
                <button class="btn-edit" (click)="toggleEditMode()">
                    <span class="material-icons-outlined">edit</span>
                </button>
                <button class="btn-delete" (click)="deleteUser()">
                    <span class="material-icons-outlined">delete</span>
                </button>
            </ng-container>
            <ng-container *ngIf="editMode">
                <action-button
                    class="btn-save"
                    (actionEvent)="saveUser($event)"
                    icon="save">
                </action-button>
                <button class="btn-cancel" (click)="toggleEditMode()">
                    <span class="material-icons-outlined">cancel</span>
                </button>
            </ng-container>
        </div>
    </div>

    <div *ngIf="UserEmpty()" class="empty-details">
        <span class="material-icons-outlined">person</span>
    </div>

    <div *ngIf="!UserEmpty()" class="user-info-container">

        <div *ngIf="user.value.id !== 0 && !editMode" class="user-info">
            <table>
                <tr class="info-row">
                    <td><strong class="label">{{ "userDetails.name" | translate }}</strong></td>
                    <td><span class="value">{{ user.value.name }}</span></td>
                </tr>
                <tr class="info-row">
                    <td><strong class="label">{{ "userDetails.displayname" | translate }}</strong></td>
                    <td><span class="value">{{ user.value.displayname }}</span></td>
                </tr>
                <tr class="info-row">
                    <td><strong class="label">{{ "userDetails.email" | translate }}</strong></td>
                    <td><span class="value">{{ user.value.email }}</span></td>
                </tr>
                <tr class="info-row">
                    <td><strong class="label">{{ "userDetails.supervisor" | translate }}</strong></td>
                    <td>
                        <span class="bool-badge" [class.bool-yes]="user.value.supervisor">
                            {{ user.value.supervisor ? 'yes' : 'no' }}
                        </span>
                    </td>
                </tr>
                <tr class="info-row">
                    <td><strong class="label">{{ "userDetails.active" | translate }}</strong></td>
                    <td>
                        <span class="bool-badge" [class.bool-yes]="user.value.active">
                            {{ user.value.active ? 'yes' : 'no' }}
                        </span>
                    </td>
                </tr>
            </table>

            <user-pass
                *ngIf="supervisor && userPassFormVisible"
                (cancel)="cancelPasswordChange()"
                [selectedUsername]="selectedUser">
            </user-pass>

            <div *ngIf="supervisor && !userPassFormVisible" class="password-section">
                <button class="btn-password" (click)="userPassFormVisible = true">
                    <span class="material-icons-outlined">lock_reset</span>
                    {{ 'resetPassword.title' | translate }}
                </button>
            </div>

            <messages
                [form]="userForm"
                [messagesObserver]="messages"
                [showNonFieldKeys]="TRUE"
                [showFieldName]="TRUE"
                [showFieldKeys]="FALSE">
            </messages>
        </div>

        <form [formGroup]="userForm" *ngIf="editMode" class="user-form">
            <div class="form-group">
                <label for="name">{{ "userDetails.name" | translate }}</label>
                <input type="text" id="name" formControlName="name" />
                <messages [form]="userForm" [messagesObserver]="messages" fieldname="name"></messages>
            </div>
            <div class="form-group">
                <label for="displayname">{{ "userDetails.displayname" | translate }}</label>
                <input type="text" id="displayname" formControlName="displayname" />
                <messages [form]="userForm" [messagesObserver]="messages" fieldname="displayname"></messages>
            </div>
            <div class="form-group">
                <label for="email">{{ "userDetails.email" | translate }}</label>
                <input type="email" id="email" formControlName="email" />
                <messages [form]="userForm" [messagesObserver]="messages" fieldname="email"></messages>
            </div>
            <div class="check-row">
                <div class="check-group">
                    <input type="checkbox" id="supervisor" formControlName="supervisor" />
                    <label for="supervisor">{{ "userDetails.supervisor" | translate }}</label>
                </div>
                <div class="check-group">
                    <input type="checkbox" id="active" formControlName="active" />
                    <label for="active">{{ "userDetails.active" | translate }}</label>
                </div>
            </div>
            <messages
                [form]="userForm"
                [messagesObserver]="messages"
                [showNonFieldKeys]="TRUE"
                [showFieldName]="TRUE"
                [showFieldKeys]="FALSE">
            </messages>
        </form>

    </div>
</div>
